/* unplugin-vue-components disabled */import script from "./PopupDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./PopupDrawer.vue?vue&type=script&setup=true&lang=js"

import "./PopupDrawer.vue?vue&type=style&index=0&id=3536daee&lang=scss"
import "./PopupDrawer.vue?vue&type=style&index=1&id=3536daee&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3536daee"]])

export default __exports__